<template>
    <dashboard>
        <row>
            <panel>
                <h3 slot="title">Students</h3>
                <template slot="buttons">
                    <app-button size="small" @click="showEditStudent = true">Add Student</app-button>
                </template>

                <student-table
                    :items="students"
                    :sort-by="sort_by"
                    :columns="['bulk','apa','first_name','last_name','email']"
                    @sort-change="sortChange">
                    <template slot="actions">
                        <el-table-column label="Actions" width="150px" align="right">
                            <template slot-scope="scope">
                                <app-tooltip effect="dark" content="Remove From Team" placement="top-end">
                                    <app-button
                                        type="danger"
                                        size="mini"
                                        icon="icon-delete"
                                        @click.stop="handleRemove(scope.$index, scope.row)">
                                        <span class="visuallyhidden">Remove Student From Team</span>
                                    </app-button>
                                </app-tooltip>
                            </template>
                        </el-table-column>
                    </template>
                </student-table>

                <div class="footer">
                    <pagination
                        :current-page="page"
                        :page-size="per_page"
                        :total="total"
                        layout="prev, pager, next, total"
                        @current-change="pageChange"/>
                    <div class="bulk-actions">
                        <label for="bulk-student-actions" class="visuallyhidden"> Select Bulk Action </label>
                        <app-select
                            id="bulk-student-actions"
                            v-model="bulkAction"
                            title="Select Bulk Action"
                            size="small"
                            placeholder="Bulk Student Actions">
                            <app-option
                                v-for="item in actions"
                                :key="item"
                                :label="item"
                                :value="item"/>
                        </app-select>
                        <app-button
                            :loading="loading"
                            :disabled="bulkDisable"
                            class="perform-action"
                            size="small"
                            @click="performBulkAction">Perform Action</app-button>
                    </div>
                </div>
            </panel>
        </row>

        <modal v-model="showEditStudent">
            <team-add-student :team_id="team.id" @reload="getStudents(getParameters())"/>
        </modal>

        <component
            :is="selectedBulkAction"
            v-model="showBulkAction"
            @selected-class="addBulkToSelection"
            @selected-event="addBulkToSelection"
            @selected-team="addBulkToSelection">
            <template slot="title">{{ bulkAction }}</template>
        </component>
    </dashboard>
</template>

<script>
import table from '@/mixins/table'
import selectable from '@/mixins/selectable'
import Student from '@/store/models/Student'

import StudentTable from '../Student/StudentTable'
import TeamAddStudent from './TeamAddStudent'
import CoursePicker from '../Course/CoursePicker'
import EventPicker from '../Event/EventPicker'
import TeamPicker from '../Team/TeamPicker'

export default {
    name: 'page-students',
    components: {
        StudentTable,
        TeamAddStudent,
        CoursePicker,
        EventPicker,
        TeamPicker
    },
    mixins: [table, selectable],
    props: ['team', 'uuid'],
    data() {
        return {
            showEditStudent: false,
            relation: 'teams',
            tableParamKeys: ['relation', 'relation_uuid'],
            studentIds: [],
            total: 0
        }
    },
    computed: {
        students() {
            return Student.query()
                .withAll()
                .whereIdIn(this.studentIds)
                .get() 
        },
        relation_uuid() {
            return this.uuid
        }
    },
    mounted() {
        this.getStudents(this.getParameters())
    },
    methods: {
        navigateToStudentDetail(student) {
            this.$router.push({
                name: 'students.detail',
                params: { uuid: student.uuid }
            })
        },
        getStudents(params) {
            Student.$fetch({
                graphql: 'all',
                variables: params
            }).then(({ data, raw }) => {
                this.studentIds = data.map((item) => item.id)
                this.total = raw.total
            })
        },
        paramsChanged(params) {
            this.getStudents(params)
        },
        handleRemove(index, student) {
            this.$confirm({
                title: 'Confirm',
                message: 'Are you sure you want to remove this student?'
            })
                .then(() => {
                    return student.$detach(
                        this.team.id, 'teams', 'removeStudentFromTeam', true
                    )
                })
                .then(() => {
                    return this.getStudents(this.getParameters())
                })
                .then(() => {
                    this.$notify({
                        title: 'Success',
                        message: 'The student has been removed from the team.',
                        type: 'success',
                        offset: 75,
                        duration: 2000
                    })
                })
        },
        stateChange(state) {
            let params = this.getParameters()
            params.state = state
            this.setParameters(params)
        }
    }
}
</script>

<style lang="stylus">
.footer
    display: flex
    flex-direction: row
    justify-content: space-between
    align-content: center

.bulk-actions
    padding: 15px 0px 0px
    @media screen and (max-width: 640px)
        display: none

.perform-action
    margin-left: 15px
</style>
